import { render, staticRenderFns } from "./PromotionalCard.vue?vue&type=template&id=90b88ad4&scoped=true&"
import script from "./PromotionalCard.vue?vue&type=script&lang=js&"
export * from "./PromotionalCard.vue?vue&type=script&lang=js&"
import style0 from "./PromotionalCard.vue?vue&type=style&index=0&id=90b88ad4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b88ad4",
  null
  
)

export default component.exports